import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button, OverlayTrigger } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import { FaRegFolderOpen } from "react-icons/fa6";
import { BiSolidDuplicate } from "react-icons/bi";
import { usdCurrencyFormat } from './numberFormats';

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'10%'}}>Fast Quote Number</th>
        <th style={{width:'5%'}}>Version Number</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Created By</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Created At</th>
        <th className='d-none d-sm-table-cell' style={{width:'5%'}}>Surcharge</th>
        <th className='d-none d-sm-table-cell' style={{width:'5%'}}>Packing</th>
        <th className='d-none d-sm-table-cell' style={{width:'5%'}}>Hinge Boring</th>        
        <th className='d-none d-sm-table-cell' style={{width:'5%'}}>Dellivery</th>  
        <th className='d-none d-sm-table-cell' style={{width:'5%'}}>Total Price Doors</th>              
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>TOTAL QUOTED AMOUNT</th>        
        <th style={{width:'5%'}}>{props.mode==0?'Open':''}</th>
        <th style={{width:'5%'}}>Duplicate</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.FastQuotingDoorVersionsObj) {
    const rows = props.FastQuotingDoorVersionsObj.map((row, index) => { 
      const total_hinge_bore_cost = row.doorcalculation.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.hinge_bore_cost);
      }, 0); // 0 is the initial value of the accumulator   
      const total_price_doors = row.doorcalculation.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.total_price_door);
      }, 0); // 0 is the initial value of the accumulator         
      return (      
        <tr key={index}>   
          <td>
            {row.fastquotingdoor.fastquotingdoornumber}
          </td>    
          <td>      
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderEditTooltip}>
              <Link
                versionnumber = {row.versionnumber}
                to={`/view-cabinet-fast-quote-versions/${row.id}`}
              >              
                {String(row.versionnumber).padStart(5, '0')}
              </Link>  
            </OverlayTrigger>         
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.user?row.user.userlastname + ", " + row.user.userfirstname:null}
          </td>   
          <td className='d-none d-sm-table-cell'>  
            {new Date(row.createdAt).toUTCString()}
          </td>            
          <td className='d-none d-sm-table-cell' style={{textAlign:'right'}}>  
            {usdCurrencyFormat(row.surcharge)}
          </td>
          <td className='d-none d-sm-table-cell' style={{textAlign:'right'}}>
            {usdCurrencyFormat(row.packing)}
          </td>  
          <td className='d-none d-sm-table-cell' style={{textAlign:'right'}}>
            {usdCurrencyFormat(total_hinge_bore_cost)}
          </td>                 
           
          <td className='d-none d-sm-table-cell' style={{textAlign:'right'}}>  
            {usdCurrencyFormat(row.delivery_cost)}
          </td> 
          <td className='d-none d-sm-table-cell' style={{textAlign:'right'}}>  
            {usdCurrencyFormat(total_price_doors)}
          </td>           
          <td className='d-none d-sm-table-cell' style={{textAlign:'right'}}>  
            {usdCurrencyFormat(row.surcharge+row.packing+total_hinge_bore_cost+row.delivery_cost+total_price_doors)}
          </td>                     
          <td align='center'>  
            {(props.mode==0) &&
              <Button variant='success'><Link to = {`/view-door-fast-quoting/${row.id}`}><FaRegFolderOpen color='white'/></Link></Button>          
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                console.log(row);
                props.onSelected(row.id,row.baseCabinets,row.tallCabinets,row.wallCabinets);
                props.handleClose();
              }} variant='success' value={row.id}>Select</Button>
            } 
          </td >   
          <td align='center'>  
            <Button variant='success' onClick={() => {
              props.duplicateVersion(row.fastquotingdoorId, row.id);
            }}>
              <BiSolidDuplicate />
            </Button>
            
          </td>         
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to view and create quote versions.
  </Tooltip>
);



const FastQuoteDoorVersionsList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline", marginLeft:"13px",width:"99%"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode} />
            <TableBody 
              handleClose={props.handleClose} 
              onSelected={props.onSelected} 
              mode={props.mode} 
              FastQuotingDoorVersionsObj={props.listOfFastQuotingDoorVersions} 
              duplicateVersion={props.duplicateVersion}
            />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default FastQuoteDoorVersionsList;